import { faCube } from "@fortawesome/pro-solid-svg-icons";
import PanelVisualisation from "@tosize/panel-visualisation";
import type { Workpiece } from "@tosize/shapes/src/types/workpiece";
import { Button, Dialog, cn } from "@tosize/ui";
import { Fragment, useState } from "react";
import { useIntl } from "react-intl";
import { useConfig } from "../../../context/ConfigContext";
import { usePostDataContext } from "../../../context/PostDataContext";
import useFinishes from "../../../hooks/useFinishes";
import useProducts from "../../../hooks/useProducts";
import useShapes from "../../../hooks/useShapes";

export function VisualisationDialog() {
	const intl = useIntl();
	const { workpiece } = usePostDataContext();
	const { productData } = useProducts();
	const { shape } = useShapes();
	const { finishInputs } = useFinishes();
	const { mode, apiUrl, cartId } = useConfig();
	const [open, onOpenChange] = useState(false);

	return (
		<Fragment>
			<Button
				className={cn({ "lg:hidden": mode === "add" })}
				variant="link"
				starticon={faCube}
				onClick={() => onOpenChange(!open)}
			>
				{open
					? intl.formatMessage(
							{
								defaultMessage: "Verberg de 3D visualisatie van jouw {value}",
								id: "lWfPkL",
							},
							{ value: shape?.name.toLocaleLowerCase() },
						)
					: intl.formatMessage(
							{
								defaultMessage: "Bekijk de 3D visualisatie van jouw {value}",
								id: "ba+StU",
							},
							{ value: shape?.name.toLocaleLowerCase() },
						)}
			</Button>
			<Dialog
				title={intl.formatMessage(
					{ defaultMessage: "3D visualisatie van jouw {value}", id: "zg6En0" },
					{ value: shape?.name.toLocaleLowerCase() },
				)}
				open={open}
				onOpenChange={(o) => onOpenChange(o)}
			>
				<div className="aspect-video">
					<PanelVisualisation
						messages={intl.messages}
						cartId={cartId}
						apiUrl={apiUrl}
						workpiece={workpiece as Workpiece}
						thickness={productData?.thickness}
						grainType={productData?.grain_type ?? undefined}
						shape={shape}
						finishInputs={finishInputs}
						variant="dialog"
						modus="dimensions"
						open
						lang={intl.locale}
					/>
				</div>
			</Dialog>
		</Fragment>
	);
}
